<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    :selectedIndex="undefined"
    ref="gc-base-layout"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="'Create Survey Template'"
        :createModeIsEditMode="true"
        :baseView="baseView"
        :primaryLabel="getPrimaryLabel"
        :secondaryLabel="getSecondaryLabel"
        v-if="loaded"
      />
    </template>

    <div class="create-survey-template css-v2 transaction-screen" v-if="loaded">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="model"
          :itemSaveCallBack="checkHeaderFormValidation"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
        ></gc-form-header-toolbar>
      </div>

      <div class="header-form-container">
        <div class="header-form-1">
          <div class="view-card responsive-paddings">
            <gc-form
              :formOptions="{
                gcLabelLocation: 'left',
              }"
              :formItems="getHeaderFormItems"
              :isNormal="true"
              :data-model="model"
              :formContentReady="formContentReady"
              :formMode="baseView.mode"
              :fromFrom="'gc-header-form'"
              ref="gc-header-form"
              :valueChangeCallBack="headerFormValueChanged"
              :checkValid="isValid"
              :validationGroup="'gc-header-form'"
              :scrollingEnabled="false"
              :formHeight="100"
            ></gc-form>
          </div>
        </div>
      </div>

      <div class="template-container">
        <div class="customer-selection">
          <GcDataGrid
            :grouping="true"
            :export="true"
            :summary="true"
            :dataSourceConfig="getCustomerSelection.gridOptions.dataSource"
            :columns="getCustomerSelection.columns"
            :id="'selection-grid'"
            ref="selection-grid"
            :isLocalDataSource="
              getCustomerSelection.gridOptions.dataSource.localDataList
                ? true
                : false
            "
            :isEditableGrid="false"
            :showFooter="false"
            :gridOptions="getCustomerSelection.gridOptions"
            :rowClick="undefined"
            :gridToolbar="getCustomerSelection.toolbar"
            :exportFileName="undefined"
            v-if="loaded"
            :persistenceKey="undefined"
            :heightPadding="225"
            :filterHeightAdjustment="195"
            :toolbarHeader="{
              primary: 'Customers',
              secondary: undefined,
            }"
            :getSelectedRowKeys="
              baseView.mode == 'edit' ? getSelectedRowKeys : undefined
            "
          />
        </div>

        <div class="questions-container">
          <div class="heading">
            <span> <h4>Questions</h4></span>
            <DxButton
              :icon="'plus'"
              class="add-new-btn override-styles"
              :text="'Add New'"
              type="default"
              @click="addMoreQuestions"
              :visible="baseView.mode != 'review'"
            />
          </div>
          <hr />

          <div
            class="questions"
            v-bind:style="{
              'max-height': scrollViewHeight + 'px',
            }"
          >
            <div
              class="question"
              v-for="(item, index) in NumOfQuestions"
              v-bind:key="index"
            >
              <div>
                <div class="toolbar">
                  <span>Question</span>

                  <DxTextArea
                    :element-attr="{
                      id: 'question-' + index,
                      class: 'questions-text',
                    }"
                    height="80"
                    width="100%"
                    :value="item.Question"
                    @value-changed="onQuestionValueChanged($event, item)"
                    :read-only="baseView.mode == 'review'"
                    @initialized="onQuestionFieldInitialized"
                    @keyDown="onQuestionKeyDown($event, index)"
                    :ref="'questions-text-area-' + index"
                  />
                  <DxButton
                    :icon="'trash'"
                    class="delete-btn"
                    @click="deleteQuestion(index)"
                    :visible="baseView.mode != 'review'"
                    :tabIndex="-1"
                  />
                </div>

                <div class="question-content">
                  <DxCheckBox
                    :text="'Image Required'"
                    :value="item.Image"
                    :on-value-changed="
                      (e) => {
                        item.Image = e.value;
                      }
                    "
                    :read-only="baseView.mode == 'review'"
                  />
                  <DxCheckBox
                    :text="'Note Required'"
                    :value="item.Note"
                    :on-value-changed="
                      (e) => {
                        item.Note = e.value;
                      }
                    "
                    :read-only="baseView.mode == 'review'"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- </DxScrollView> -->
        </div>
      </div>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import validationEngine from "devextreme/ui/validation_engine";

import { SurveyTemplateService } from "@/_services/api/settings/sales/survey-template.service";
import { FeatureStorage } from "../../../_services/storage";

export default {
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {},
  data() {
    return {
      loaded: false,
      previewVisible: false,
      isValid: false,
      model: {
        Status: undefined,
        SurveyName: undefined,
        Description: undefined,
        StartDate: new Date(),
        EndDate: undefined,
        NextStatus: undefined,
      },
      NumOfQuestions: [],
      previewImg: undefined,
      imgDataModel: {},
      customerName: "",
      backButtonRoute: "/survey-template",
      scrollViewHeight: undefined,
      selectedCustomers: [],
      getSelectedRowKeys: [],
      recordedCustomers: [],
      addNewNote: false,
    };
  },

  async created() {},
  async mounted() {
    this.initialized();
  },
  beforeDestroy() {},
  computed: {
    getCustomerSelection() {
      return {
        gridOptions: {
          dataSource: {
            endpoint:
              this.baseView.mode == "review"
                ? "SurveyTemplateCustomerList"
                : "CustomerList",
            filter: this.getFilters,
            serverPaging: true,
            allowGrouping: false,
            select:
              this.baseView.mode == "review"
                ? undefined
                : ["Code", "Status", "FriendlyActive"].concat(
                    this.getSelectFields(this.getColumns)
                  ),
            key: this.baseView.mode == "review" ? "CustomerCode" : "Code",
            keyType: {
              SurveyTemplateRecordID: "Guid",
            },
          },
          options: {
            wordWrapEnabled: false,
            selectionMode: this.baseView.mode != "review" ? "multiple" : "none",
            rowSelectCallBack: this.onRowSelectCallBack,
          },
          noDataMessage: {
            addNew: {
              class: "add-new",
              title: "No Customers",
              message: "Get Started, Add a Customer",
            },
          },
        },

        toolbar: {
          search: false,
          columnChooser: false,
          export: false,
          openFilter: true,
          expand: false,
          customButtons: undefined,
          filterOnEnter: true,
          title: "Customers",
          header: true,
        },
        columns: this.getColumns,
      };
    },
    getColumns() {
      return [
        {
          screenField: "Customer",
          gridDataField:
            this.baseView.mode == "review" ? "CustomerName" : "Name",
          sortOrder: "asc",
          sortIndex: 0,
          cellTemplateRecord: {
            primary: [
              {
                dataField:
                  this.baseView.mode == "review" ? "CustomerName" : "Name",
              },
            ],
            secondary: [
              {
                dataField:
                  this.baseView.mode == "review" ? "CustomerCode" : "Code",
              },
            ],
          },
          exportFields: [
            {
              dataField:
                this.baseView.mode == "review" ? "CustomerCode" : "Code",
              label: "Customer Code",
            },
            {
              dataField:
                this.baseView.mode == "review" ? "CustomerName" : "Name",
              label: "Customer Name",
            },
          ],
          fixed: true,
          fixedPosition: "left",
          allowHiding: false,
        },
        {
          screenField: "CustomerName",
          gridLabel: "CustomerNameFilter", // only added to bypass the having the same 'name' for 2 columns
          visible: false,
          showInColumnChooser: false,
          dataType: "string",
          type: "Text",
          filterIndex: 0,
          filterDataField: "CustomerSearchText",
        },
        {
          screenField: "BillToCustomer",
          filterIndex: 2,
          visible: false,
        },
        {
          screenField: "CustomerType",
          label: "Type",
          filterIndex: 5,
          visible: false,
        },
        {
          screenField: "Market",
          dataField: "MarketCode",
          filterDataField: "MarketCode",
          filterIndex: 11,
          visible: false,
        },

        {
          screenField: "CustomerReportingGroup1",
          dataField: "ReportingGroup1Code",
          filterDataField: "ReportingGroup1Code",
          filterIndex: 12,
          visible: false,
        },
        {
          screenField: "CustomerReportingGroup2",
          dataField: "ReportingGroup2Code",
          filterDataField: "ReportingGroup2Code",
          filterIndex: 13,
          visible: false,
        },
        {
          screenField: "CustomerReportingGroup3",
          dataField: "ReportingGroup3Code",
          filterDataField: "ReportingGroup3Code",
          filterIndex: 14,
          visible: false,
        },
        {
          screenField: "CustomerGroup",
          label: "Group",
          filterIndex: 4,
          visible: false,
        },
        {
          screenField: "Status",
          gridDataField: "Inactive",
          gridLabel: "Status",
          filterDefaultValue: ["N"],
          visible: false,
        },
      ];
    },
    getPrimaryLabel() {
      if (this.baseView.mode == "create") return `Create Survey Template`;
      else {
        return "Survey Template for";
      }
    },
    getSecondaryLabel() {
      if (this.baseView.mode == "create") return undefined;
      else {
        return this.model.SurveyName;
      }
    },
    getHeaderToolbar() {
      return {
        audit: true,
        status: true,
        questions: false,
        save: this.model.Status == "N",
        editURL: "/survey-template",
        editVisible: FeatureStorage.checkPermission("SurveyTemplate", "edit"),
        saveKey: true,
        saveOptions:
          this.baseView.mode != "create"
            ? {
                tabIndex: -1,
                items: [
                  {
                    text: "Update",
                    id: this.model.Status,
                  },
                  {
                    text: "Cancel",
                    id: "X",
                    visible: this.model.Status == "N",
                  },
                ],
                keyExpr: "id",
                displayExpr: "text",
                dropDownOptions: {
                  width: "100px",
                },
                saveKey: "NextStatus",
              }
            : undefined,
        auditItems: [
          {
            itemType: "group",
            caption: "",
            items: [
              {
                dataField: "FormattedDateCreated",
                label: { text: "Created By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // // disabled: true,
                },
              },
              {
                dataField: "FormattedDateChanged",
                label: { text: "Changed By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // disabled: true,
                },
              },
            ],
          },
        ],
      };
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          cssClass: "header-form-items",
          colCount: 3,
          items: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  screenField: "SurveyName",
                  dataField: "SurveyName",
                  required: true,
                  editorOptions: {
                    tabIndex: 1,
                    // onValueChanged: this.onDateInValueChanged.bind(this),
                  },
                },
                {
                  label: {
                    text: "Start Date",
                  },
                  dataField: "StartDate",
                  required: true,
                  editorType: "dxDateBox",
                  // cssClass: "start-call-date",
                  editorOptions: {
                    showAnalogClock: true,
                    pickerType: "calendar",
                    step: 1,
                    tabIndex: 3,
                    type: "date",
                    displayFormat: "dd MMM yyyy",
                    calendarOptions: {
                      step: 1,
                    },
                  },
                },
                {
                  label: {
                    text: "End Date",
                  },
                  dataField: "EndDate",
                  required: true,
                  editorType: "dxDateBox",
                  // cssClass: "start-call-date",
                  editorOptions: {
                    showAnalogClock: true,
                    pickerType: "calendar",
                    tabIndex: 3,
                    type: "date",
                    displayFormat: "dd MMM yyyy",
                    min: this.model.StartDate,
                  },
                },
              ],
            },

            {
              itemType: "group",
              caption: "",
              colCount: 1,
              colSpan: 2,
              items: [
                {
                  label: {
                    text: "Description",
                  },
                  dataField: "Description",
                  editorType: "dxTextArea",
                  // cssClass: "CallPurpose",
                  editorOptions: {
                    tabIndex: 5,
                    height: 100,
                    onKeyDown: (e) => {
                      if (e.event.keyCode == 9 && !e.event.shiftKey) {
                        e.event.preventDefault();
                        if (this.$refs["questions-text-area-0"]) {
                          this.$refs[
                            "questions-text-area-0"
                          ][0].instance.focus();
                        }
                      }
                    },
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    getFilters() {
      if (this.baseView.mode != "review") {
        return [["Inactive", "=", "N"]];
      } else {
        return [["SurveyTemplateRecordID", "=", this.baseView.id]];
      }
    },
  },
  methods: {
    onRowSelectCallBack(e) {
      this.selectedCustomers = e;
    },
    formContentReady(e) {
      if (e && this.baseView.mode == "create") {
        // let customerCodeEditor = e.component
        //   .instance()
        //   .getEditor("CustomerCode");
        // if (!customerCodeEditor.option("value")) {
        //   customerCodeEditor.focus();
        // }
      }
    },
    onQuestionFieldInitialized(e) {
      setTimeout(() => {
        if (this.addNewNote) {
          e.component.instance().focus();
          this.addNewNote = false;
        }
      }, 250);
    },
    onQuestionKeyDown(e, index) {
      // TabKey
      if (e.event.keyCode == 9 && e.event.shiftKey && index == 0) {
        e.event.preventDefault();

        if (this.$refs["gc-header-form"])
          this.$refs["gc-header-form"].$refs["gc-form-comp"].instance
            .getEditor("Description")
            .focus();
      }
    },

    onQuestionValueChanged(e, item) {
      item.Question = e.value;
    },
    async deleteQuestion(index) {
      let confirmDelete = await this.$confirm(
        "Are you sure you wants to delete this question?",
        "Delete Question"
      );

      if (confirmDelete) this.NumOfQuestions.splice(index, 1);

      if (this.NumOfQuestions.length == 0)
        this.NumOfQuestions.push({
          Question: undefined,
          Image: false,
          Note: false,
          imageSrcs: [],
        });
    },
    addMoreQuestions() {
      this.showLoading(true);
      this.addNewNote = true;
      this.NumOfQuestions.push({
        Question: undefined,
        Image: false,
        Note: false,
        imageSrcs: [],
      });
      setTimeout(() => {
        this.showLoading(false);
      }, 250);
    },

    async checkHeaderFormValidation() {
      let confirmCancel = undefined;
      if (this.model.NextStatus == "X")
        confirmCancel = await this.$confirm(
          "Are you sure you wants to cancel this template ?",
          "Cancel Survey Template"
        );

      if (confirmCancel == false) {
        this.model.NextStatus = undefined;
        return;
      } else {
        if (this.model.NextStatus) this.model.Status = this.model.NextStatus;
      }

      if (this.model.StartDate > this.model.EndDate) {
        this.displayValidationErrors(["End date cannot be before Start date."]);
        return;
      }

      let headerform = await validationEngine.validateGroup("gc-header-form");
      if (this.selectedCustomers.length == 0) {
        headerform.isValid = false;
        headerform.brokenRules.push({
          message: "At least one Customer needs to be selected",
        });
      }

      if (this.NumOfQuestions.find((x) => x.Question) == undefined) {
        headerform.isValid = false;
        headerform.brokenRules.push({
          message: "At least one Question needs to be added",
        });
      }

      if (!headerform.isValid)
        this.displayValidationSummary(headerform.brokenRules);
      else {
        var payload = {
          Description: this.model.Description,
          EndDate: new Date(this.model.EndDate.toSaveDateEndTime()),
          RecordId: this.baseView.id
            ? this.baseView.id
            : "00000000-0000-0000-0000-000000000000",
          StartDate: new Date(this.model.StartDate),
          Status: this.model.Status,
          SurveyName: this.model.SurveyName,
          SurveyTemplateCustomers: [],
          SurveyTemplateQuestions: [],
        };

        this.selectedCustomers.forEach((element) => {
          var cus = this.recordedCustomers.find(
            (x) => x.CustomerCode == element.Code
          );

          payload.SurveyTemplateCustomers.push({
            CustomerCode: element.Code,
            RecordId: cus
              ? cus.RecordId
                ? cus.RecordId
                : "00000000-0000-0000-0000-000000000000"
              : "00000000-0000-0000-0000-000000000000",
            SurveyTemplateRecordID: this.baseView.id
              ? this.baseView.id
              : "00000000-0000-0000-0000-000000000000",
          });
        });

        this.NumOfQuestions.forEach((element, index) => {
          payload.SurveyTemplateQuestions.push({
            ImageRequired: element.Image ? "Y" : "N",
            NoteRequired: element.Note ? "Y" : "N",
            Question: element.Question,
            RecordId: element.RecordId
              ? element.RecordId
              : "00000000-0000-0000-0000-000000000000",
            Sequence: index++,
            SurveyTemplateRecordID: this.baseView.id
              ? this.baseView.id
              : "00000000-0000-0000-0000-000000000000",
          });
        });

        this.showLoading(true);
        await SurveyTemplateService.saveSurveyTemplate(payload)
          .then((res) => {
            // console.log("saveSurveyTemplate ", res);
            if (res) this.showLoading(false);

            this.setIgnoreRouteChangeConfirmation();
            this.$router
              .push({
                path: "/survey-template/review/" + res.data.RecordId,
              })
              .then(() => {
                this.initialized();
              });
          })
          .catch((err) => {
            if (err) this.displayServerError(err, "Save Failed");
            this.showLoading(false);
          });
      }
    },
    headerFormValueChanged(isValid, brokenRules) {
      this.isValid = false;
      if (!isValid) this.displayValidationSummary(brokenRules);
    },
    backButtonFunction() {
      this.$router.push({
        path: this.backButtonRoute,
      });
    },

    async initialized() {
      this.NumOfQuestions = [];
      if (this.baseView.mode != "create") {
        this.showLoading(true);
        await SurveyTemplateService.getByRecordId(this.baseView.id)
          .then(async (res) => {
            if (res.data.value) {
              var surveyTemplateRecord = res.data.value[0];

              this.model.Status = surveyTemplateRecord.Status;
              this.model.SurveyName = surveyTemplateRecord.SurveyName;
              this.model.Description = surveyTemplateRecord.Description;
              this.model.StartDate = new Date(surveyTemplateRecord.StartDate);

              this.model.DateCreated = surveyTemplateRecord.DateCreated;
              this.model.DateChanged = surveyTemplateRecord.DateChanged;
              this.model.CreatedBy = surveyTemplateRecord.CreatedBy;
              this.model.ChangedBy = surveyTemplateRecord.ChangedBy;

              if (surveyTemplateRecord.EndDate)
                this.model.EndDate = new Date(surveyTemplateRecord.EndDate);

              await SurveyTemplateService.getQuestionsBySurveyTemplateId(
                this.baseView.id
              )
                .then(async (res) => {
                  res.data.value.forEach((element) => {
                    this.NumOfQuestions.push({
                      Question: element.Question,
                      Image: element.ImageRequired == "Y" ? true : false,
                      Note: element.NoteRequired == "Y" ? true : false,
                      Sequence: element.Sequence,
                      RecordId: element.RecordId,
                    });
                  });

                  await SurveyTemplateService.getCustomersBySurveyTemplateId(
                    this.baseView.id
                  )
                    .then((res) => {
                      this.showLoading(false);

                      this.recordedCustomers = res.data.value;
                      this.recordedCustomers.forEach((element) => {
                        this.getSelectedRowKeys.push(element.CustomerCode);
                      });
                      setTimeout(() => {
                        this.loaded = true;
                        // eslint-disable-next-line no-console
                        console.log("AA ", this.model);
                      }, 1);
                    })
                    .catch((err) => {
                      if (err) this.showLoading(false);
                      this.loaded = true;
                    });
                })
                .catch((err) => {
                  if (err) this.showLoading(false);
                  this.loaded = true;
                });
            }
          })
          .catch((err) => {
            if (err) this.showLoading(false);
            this.loaded = true;
          });
      } else {
        this.NumOfQuestions.push({
          Question: undefined,
          Image: false,
          Note: false,
        });

        this.model.Status = "N";

        if (this.baseView.query) {
          if (this.baseView.query.cus_id)
            this.model.CustomerCode = this.baseView.query.cus_id;
          if (this.baseView.query.from)
            this.backButtonRoute = this.baseView.query.from;
        }
        this.loaded = true;
      }
    },
  },
  watch: {
    loaded(val) {
      if (val) {
        setTimeout(() => {
          var scrollableView = document.getElementsByClassName(
            "layout-body dx-scrollview"
          );
          this.scrollViewHeight = scrollableView[0].clientHeight - 235 - 40;
        }, 250);
      }
    },
  },
};
</script>

<style lang="scss">
.create-survey-template {
  height: 100%;
  .header-form-container {
    padding-bottom: 10px;

    .CallPurpose {
      > label {
        padding-top: 6px;
      }

      textarea {
        padding-top: 1px !important;
      }
    }

    .start-call-group {
      .start-call-date {
        padding-right: 0px !important;
      }
    }
    .end-call-group {
      .end-call-date {
        padding-right: 0px !important;
      }
    }
  }
  .questions-container {
    background-color: white;

    .heading {
      height: 45px !important;
    }

    hr {
      margin: 0 !important;
    }
    > div:first-child {
      padding: 10px;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    h4 {
      margin: 0 !important;
    }

    .questions {
      overflow-y: auto;
    }

    .question {
      padding: 10px;

      .uploader {
        .dx-fileuploader-wrapper {
          padding: 0 !important;
        }
        .dx-widget.dx-fileuploader {
          height: 100%;
          .dx-fileuploader-input-wrapper {
            height: 100%;
            border: 0px dashed transparent;
            .dx-fileuploader-input-container {
              input {
                padding: 0 !important;
              }
            }
          }
        }
        .dx-button {
          border-radius: 4px;
          background-color: #03a9f4 !important;
          color: #fff;
          display: flex;
          flex-direction: column;
          z-index: 100;
        }
      }

      > div {
        border-style: solid;
        border-color: #e8e8ed;
        border-width: 2px;
        width: 100%;
        padding: 10px;
        border-radius: 2px;
      }

      .toolbar {
        display: inline-flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-direction: row;
        width: 100%;

        > span:first-child {
          padding-top: 4px;
        }

        .questions-text {
          margin-left: 10px;
          textarea {
            padding-top: 0px !important;
          }
        }
      }

      .question-content {
        padding-top: 10px;
        div:nth-child(2) {
          padding-left: 15px;
        }
      }
    }
  }

  .template-container {
    display: inline-flex;
    width: 100%;
    flex-direction: row;
    .customer-selection {
      width: 40%;
    }
    .questions-container {
      margin-left: 10px;
      width: 60%;
    }
  }
}
</style>
